
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press/[id]",
      function () {
        return require("private-next-pages/press/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press/[id]"])
      });
    }
  